const supplierOptions = [
    {
        label: '朱雀',
        value: 0,
        children: [
            {
                label: '双呼回显',
                value: 0
            },
        ]
    },
    {
        label: '容联',
        value: 1,
        children: [
            {
                label: '网络电话',
                value: 3
            },
            {
                label: '双呼回显',
                value: 0
            },
            {
                label: '语音外呼',
                value: 4
            }
        ]
    },
    {
        label: '融营',
        value: 2,
        children: [
            {
                label: '双呼回显',
                value: 0
            },
        ]
    },
]

const callLineOptions = [
    {
        label: '网络电话',
        value: 3
    },
    {
        label: '双呼回显',
        value: 0
    },
    {
        label: '语音外呼',
        value: 4
    }
]

const columns = [
    {
        title: '外呼服务商名称',
        dataIndex: 'supplierType',
        customRender: ({text}) => {
            return { children: text.name}
        },
        key: 'supplierType',
        width: 150
    },
    {
        title: '外呼模式',
        dataIndex: 'wayType',
        key: 'wayType',
        customRender: ({text}) => {
            return { children: text.name}
        },
        width: 100
    },
    {
        title: '线路账号',
        dataIndex: 'account',
        key: 'type',
        width: 100
    },
    {
        title: '线路参数配置',
        dataIndex: 'lineAccountSetting',
        slots: { customRender: 'lineAccountSetting' },
        width: 150
    },
    {
        title: '坐席外显表',
        dataIndex: 'seatTable',
        slots: { customRender: 'seatTable' },
        width: 120
    },
    {
        title: '已应用企业',
        dataIndex: 'bizNameList',
        slots: { customRender: 'usedCompany' },
        key: 'bizNameList',
        width: 120
    },
    {
        title: '操作',
        dataIndex: 'convCount',
        slots: { customRender: 'actions' },
        key: 'convCount',
        width: 200,
        fixed: 'right'
    }
]

const seatColumns = [
    {
        title: '坐席编号',
        dataIndex: 'seat',
        width: 120
    },
    {
        title: '外显号码',
        dataIndex: 'phone',
        width: 120
    },
    {
        title: '归属地',
        dataIndex: 'city',
        width: 120
    },
]

const modalState = {
    view: '查看',
    edit: '编辑',
    add: '新增',
    uplaod: '上传'
}

export {
    supplierOptions,
    callLineOptions,
    columns,
    modalState,
    seatColumns
}
